import { jsx as _jsx } from "react/jsx-runtime";
import { SticksDataProvider, SticksProductDetails, } from "../../../../containers/SticksProductDetailsContainer";
import { getFallbackProductSkus, getSticksWithAggregationsMap } from "./utils";
export const SticksProductDetailsPage = (props) => {
    const { sticksData } = props;
    const fallbackProductSkus = getFallbackProductSkus(sticksData);
    const sticksMap = getSticksWithAggregationsMap(sticksData);
    return (_jsx(SticksDataProvider, { sticksMap: sticksMap, fallbackProductsSkus: fallbackProductSkus, ...props, children: _jsx(SticksProductDetails, {}) }));
};
//# sourceMappingURL=SticksProductDetailsPage.js.map